export default __webpack_public_path__ + "static/media/zoological garden.6b942ae3.jpg";